import { questionnaireGql } from '../../../gql-gen/questionnaire'

export const CREATE_QUESTIONNAIRE = questionnaireGql(/* GraphQL */ `
  mutation createQuestionnaireV2($projectId: ID!, $surveyId: ID!, $waveId: ID) {
    createQuestionnaireV2(
      projectId: $projectId
      surveyId: $surveyId
      waveId: $waveId
    ) {
      questionnaireId
    }
  }
`)
